import features from '~/constants/features';
import paths from '~/pages/paths';

export const redirectToExternalAuth = (sales?: boolean) => {
  const currentPath = `${window.location.pathname}`;
  const localStorgaeSalesValue = localStorage.getItem('isSalesRole') === 'true';
  const firstPath = currentPath.split('/')[1];
  if (firstPath === 'sales' || sales || localStorgaeSalesValue) {
    if (currentPath !== paths.auth.salesAuthCallback && currentPath !== paths.auth.redirectSalesToKeyCloak) {
      window.location.replace(`${paths.auth.redirectSalesToKeyCloak}?tenantId=${features.tenantId}`);
      localStorage.removeItem('isSalesRole');
    }
  } else if (firstPath === 'agent') {
    if (currentPath !== paths.auth.agentAuthCallback && currentPath !== paths.auth.redirectAgentToKeyCloak) {
      window.location.replace(`${paths.auth.redirectAgentToKeyCloak}?tenantId=${features.tenantId}`);
    }
  } else if (currentPath !== paths.auth.merchantAuthCallback && currentPath !== paths.auth.redirectToKeyCloak) {
    window.location.replace(`${paths.auth.redirectToKeyCloak}?tenantId=${features.tenantId}`);
  }
};
